import { FlowError } from './FlowError'

export const cloneErrorObject = (error: Error): FlowError => ({
  ...JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error)))
})
